import "./style.css";
import { useState, useEffect } from "react";
import BookingList from "./_components/BookingList";
import BookingListFilter from "./_components/BookingListFilter";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import { bookingSubMenu } from "../../../../../utils/dataLists";

const MyPageBookings = ({ userRole }) => {
  const [page, setpage] = useState("");
  const [filterGetBookings, setFilterGetBookings] = useState({
    search: "",
    orderBy: "pickupDateTime",
    sortBy: "asc",
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  var content = searchParams.get("content");
  const { t } = useTranslation();
  const bookingMenus = bookingSubMenu[userRole] || [];

  const getMenuContent = (menu) => {
    if (!menu) return "";

    const menuParams = new URLSearchParams((menu.params || "").replace("?", ""));
    return menuParams.get("content") || menu.name;
  };

  const defaultContent = getMenuContent(bookingMenus[0]);
  content = content || defaultContent;

  useEffect(() => {
    const activeMenu = bookingMenus.find((menu) => getMenuContent(menu) === content);

    if (activeMenu?.tag) {
      setpage(t(activeMenu.tag));
      return;
    }

    if (bookingMenus[0]?.tag) {
      setpage(t(bookingMenus[0].tag));
    }
  }, [bookingMenus, content, t]);

  // Maps the URL ?content= value to the newGetBookings type
  const contentToBookingType = {
    current: "current",
    previous: "previous",
    cancelled: "cancelled",
    this_month: "thisMonth",
    upcoming: "upcoming",
  };

  const renderContent = (contentType) => {
    const bookingType = contentToBookingType[contentType] || "upcoming";

    return (
      <BookingList
        type={bookingType}
        userRole={userRole}
        filterGetBookings={filterGetBookings}
        changeFilter={changeFilter}
        showFilter={false}
      />
    );
  };

  const changeFilter = (e) => {
    setFilterGetBookings((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:border-0 tw:shadow-none">
        {/* // DESKTOP VERSION */}
        <div className="tw:px-4 tw:md:px-7 tw:pt-4 tw:md:pt-6 tw:pb-5 tw:md:pb-9">
            <BookingListFilter
              changeFilter={changeFilter}
              selectedCards={[]}
              filterGetBookings={filterGetBookings}
            />
          </div>

        <div className="tw:flex-1 tw:p-0 tw:pb-0 tw:overflow-x-auto">
          <ul className="tw:flex tw:flex-nowrap tw:!mb-0 tw:list-none tw:flex-row tw:min-w-full tw:w-max tw:justify-start tw:items-end tw:h-[51px] tw:gap-0 tw:border-b tw:border-[#D9D9D9] tw:pl-4 tw:md:pl-7 tw:pr-4 tw:md:pr-6">
            {
              bookingMenus?.map((val) => (
                <li
                  key={val.name}
                  className={`tw:whitespace-nowrap tw:-mb-px tw:list-none tw:rounded-t-[5px] tw:px-5 tw:md:px-8 tw:py-3 ${content === getMenuContent(val)
                    ? "active tw:relative tw:border tw:border-[#282828] tw:!border-b-[#FFFFFF] tw:bg-white"
                    : "tw:border tw:border-transparent tw:bg-transparent"
                    }`}
                >
                  <Link
                    to={val.params}
                    className={`tw:p-0 tw:font-hanken-grotesk tw:!no-underline ${content === getMenuContent(val)
                      ? "tw:text-[16px] tw:font-bold tw:leading-normal tw:text-[#282828]!"
                      : "tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#8D8D8D]!"
                      }`}
                  >
                    {t(val.tag)}
                  </Link>
                </li>
              ))
            }
          </ul>
        </div>

        <div className="tw:px-4 tw:md:px-7 tw:mt-3">
          {renderContent(content)}
        </div>
      </div>
    </>
  );
};

export default MyPageBookings;
